// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__3FQ0N","dragIcon":"Choice_dragIcon__2zz0G","left":"Choice_left__1Fwcr","input":"Choice_input__2RUiz"};